























import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { TaskConfig } from './../type/TaskConfig';

// components
import Progress from './Progress.vue';
import TaskForm from './TaskForm.vue';


@Component({
  components: {
    Progress,
    TaskForm
  }
})
export default class TabItem extends Vue {

  @Prop() private task!: TaskConfig

  isOpen: boolean = false

  get going(): number {
    return this.$store.state.taskDoingId
  }
  set going(val: number) {
    this.$store.commit('SET_GOING', val)
  }

  openSectionHandler() {
    this.isOpen = !this.isOpen
  }
}
